import { useCallback, useState } from 'react';

const usePdfExport = () => {
  const [loading, setLoading] = useState(false);

  const exportToPdf = useCallback(async (element, scheduleType) => {
    if (!element) return;

    setLoading(true);
    try {
      // Lazy load de librerías solo cuando se necesitan xd
      const [{ default: html2canvas }, { default: jsPDF }] = await Promise.all([
        import('html2canvas'),
        import('jspdf'),
      ]);

      const canvas = await html2canvas(element, {
        backgroundColor: '#ffffff',
        scale: 1.5,
        logging: false,
        useCORS: true,
      });

      const imgData = canvas.toDataURL('image/jpeg', 0.7);
      const ratio = canvas.width / canvas.height;
      const orientation = ratio > 1 ? 'landscape' : 'portrait';

      const doc = new jsPDF({
        orientation,
        unit: 'mm',
        format: 'a4',
        compress: true,
      });

      doc.setFontSize(18);
      doc.text(`Horario UNAC - E.P. ${scheduleType}`, 14, 15);

      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = doc.internal.pageSize.getHeight();
      const margin = 14;
      const availableWidth = pdfWidth - margin * 2;

      let imgWidth = availableWidth;
      let imgHeight = availableWidth / ratio;

      if (imgHeight > pdfHeight - 25) {
        imgHeight = pdfHeight - 25;
        imgWidth = imgHeight * ratio;
      }

      const xOffset = margin + (availableWidth - imgWidth) / 2;
      doc.addImage(imgData, 'PNG', xOffset, 20, imgWidth, imgHeight);
      doc.save(`horario_unac_${scheduleType}.pdf`);
    } catch (err) {
      console.error('PDF export error:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  const exportToImage = useCallback(async (element, scheduleType) => {
    if (!element) return;

    setLoading(true);
    try {
      const [{ default: html2canvas }] = await Promise.all([
        import('html2canvas'),
      ]);

      const canvas = await html2canvas(element, {
        backgroundColor: null,
        scale: 2,
        logging: false,
        useCORS: true,
      });

      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = `horario_unac_${scheduleType}.png`;
      link.click();
    } catch (err) {
      console.error('Image export error:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { exportToPdf, exportToImage, loading };
};

export default usePdfExport;